/**
 * TanStack Query hooks for `cross-channel-attribution`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	crossChannelAttributionQueryKeys,
	type CreateCrossChannelAttributionBody,
	type ListCrossChannelAttributionResponse,
	type CrossChannelAttributionRow,
} from "./api";

export function useCrossChannelAttributionList(): UseQueryResult<ListCrossChannelAttributionResponse, Error> {
	return useQuery({
		queryKey: crossChannelAttributionQueryKeys.list(),
		queryFn: list,
	});
}

export function useCrossChannelAttributionCreate(): UseMutationResult<CrossChannelAttributionRow, Error, CreateCrossChannelAttributionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: crossChannelAttributionQueryKeys.all });
		},
	});
}

export function useCrossChannelAttributionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: crossChannelAttributionQueryKeys.all });
		},
	});
}
